import React from 'react'
import moment from 'moment'
import { css } from 'aphrodite'

import style from '../style'

const Selector = props => {
  return (
    <select
      className={css(
        style.selector.select,
        style[props.theme.name] ? style[props.theme.name].selector.select : null
      )}
      value={props.value}
      onChange={props.onChange}
    >
      {props.options.map((d, index) => (
        <SelectorOption key={`${index}`} {...d} />
      ))}
    </select>
  )
}

const SelectorOption = props => {
  const value = moment(props.date).format('YYYY-MM-DD')
  const index = props.index
  const label = props.label

  return (
    <option key={index} value={value}>
      {label}
    </option>
  )
}

export default Selector



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/DateSelector.js